import script from "./AllLatencyView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AllLatencyView.vue?vue&type=script&setup=true&lang=ts"

import "./AllLatencyView.vue?vue&type=style&index=0&id=441af85a&lang=css"

const __exports__ = script;

export default __exports__